import React, { FC } from "react";
import PromptMediaFileAndLinkContainer from "@src/features/libraryItem/course/PromptMediaFileAndLinkContainer";
import VolumeUpOutlineIcon from "@src/lib/icons/18px/volume-up-outline";
import Text from "@src/lib/ui/Text";
import Spacer from "@src/lib/ui/Spacer";
import useBrandColor from "@src/features/settings/hooks/useBrandColor";
import { addOpacityToHexColor } from "@src/lib/utils/color";

type Props = {
  url: string;
  title?: string;
};

const PromptMediaAudioFilePreview: FC<Props> = (props) => {
  const brandColor = useBrandColor();
  return (
    <PromptMediaFileAndLinkContainer
      centerContent={
        <div className="flex flex-col items-center p-[22px]">
          <VolumeUpOutlineIcon
            className="size-12"
            style={{ color: brandColor }}
          />
          {props.title && (
            <>
              <Spacer size={14} />
              <Text type={"H3"} fontWeight={"SemiBold"} color={brandColor}>
                {props.title}
              </Text>
            </>
          )}
        </div>
      }
      footerContent={
        <div className="flex items-center justify-center self-stretch">
          <audio
            src={props.url}
            style={{
              borderRadius: 99,
              filter: `drop-shadow(0px 0px 3.58904px ${addOpacityToHexColor(
                brandColor,
                0.5,
              )}) drop-shadow(0px 7.17809px 54.36px ${addOpacityToHexColor(
                brandColor,
                0.5,
              )})`,
            }}
            controls
          />
        </div>
      }
    />
  );
};

export default PromptMediaAudioFilePreview;
